import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import * as Ant from "antd";
import { ObjectId } from "@bluelibs/ejson";
import { Routes } from "@bundles/UIAppBundle";
import { useUIComponents, useRouter, use, useDataOne, useTranslate, } from "@bluelibs/x-ui";
import { ProfileEditForm } from "../../config/ProfileEditForm";
import { features } from "../../config/features";
import { ProfilesCollection } from "@bundles/UIAppBundle/collections";
import { formRenderItems } from "@bundles/UIAppBundle/pages/utils";
const formTailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
export function ProfilesEdit(props) {
    const UIComponents = useUIComponents();
    const t = useTranslate();
    const form = use(ProfileEditForm, { transient: true });
    const router = useRouter();
    const { data: document, isLoading, error, } = useDataOne(ProfilesCollection, new ObjectId(props.id), ProfileEditForm.getRequestBody());
    form.build();
    return (_jsxs(UIComponents.AdminLayout, { children: [_jsx(Ant.PageHeader, { title: t("management.profiles.edit.header"), onBack: () => window.history.back(), extra: features.view
                    ? [
                        _jsx(Link, { to: router.path(Routes.PROFILES_VIEW, {
                                params: { id: props.id },
                            }), children: _jsx(Ant.Button, { children: t("generics.view") }) }, "view"),
                    ]
                    : [] }), _jsxs(Ant.Card, { children: [isLoading && (_jsx(Ant.Space, { align: "center", children: _jsx(Ant.Spin, { size: "large" }) })), !isLoading && (error || !document) && (_jsx(Ant.Alert, { message: error || t("generics.error_message"), type: "error" })), !isLoading && !error && (_jsxs(Ant.Form, { requiredMark: "optional", initialValues: document, onFinish: (document) => form.onEditSubmit(props.id, document), children: [_jsx("div", { className: "input-row", children: formRenderItems(form, ["gender", "firstName", "lastName"]) }), _jsx("div", { className: "input-row", children: formRenderItems(form, ["phones", "emails"]) }), formRenderItems(form, ["address"]), _jsx(Ant.Form.Item, { children: _jsx(Ant.Button, { type: "primary", htmlType: "submit", children: t("generics.submit") }) })] }))] })] }));
}
